function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 7,
  fill: "#FFC700",
  stroke: "#FFC700",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19 9L19 5L21 5L21 9H19Z",
  fill: "#FFC700"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19 35L19 31H21L21 35H19Z",
  fill: "#FFC700"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7253 11.6882L10.3741 8.45215L11.9922 7.27658L14.3433 10.5126L12.7253 11.6882Z",
  fill: "#FFC700"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M28.0077 32.7227L25.6566 29.4866L27.2746 28.311L29.6257 31.5471L28.0077 32.7227Z",
  fill: "#FFC700"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M25.6566 10.5134L28.0078 7.27734L29.6258 8.45291L27.2746 11.689L25.6566 10.5134Z",
  fill: "#FFC700"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3742 31.5479L12.7253 28.3118L14.3434 29.4874L11.9922 32.7234L10.3742 31.5479Z",
  fill: "#FFC700"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M30.1526 15.6501L33.9568 14.4141L34.5749 16.3162L30.7707 17.5522L30.1526 15.6501Z",
  fill: "#FFC700"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M5.42515 23.6846L9.22938 22.4485L9.84741 24.3506L6.04319 25.5867L5.42515 23.6846Z",
  fill: "#FFC700"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M9.22934 17.5515L5.42511 16.3154L6.04314 14.4133L9.84737 15.6494L9.22934 17.5515Z",
  fill: "#FFC700"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M33.9568 25.5859L30.1526 24.3499L30.7706 22.4478L34.5748 23.6838L33.9568 25.5859Z",
  fill: "#FFC700"
});

var SvgSunny = function SvgSunny(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSunny, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sunny.29bd697a.svg";
export { ForwardRef as ReactComponent };